import LogoDark from "@/assets/images/allears-dark.svg";
import LogoLight from "@/assets/images/allears-light.svg";
import { useLingui } from "@lingui/react/macro";
import useActiveLanguage from "@/hooks/useActiveLanguage";
import { EN_EXTERNAL_URL, LOCALE, SE_EXTERNAL_URL } from "@/constants";

export default function PublicLogo({
  className,
  width = 60,
}: {
  className?: string;
  width?: number;
}) {
  const { t } = useLingui();
  const language = useActiveLanguage();

  return (
    <a
      href={language === LOCALE.SWEDISH ? SE_EXTERNAL_URL : EN_EXTERNAL_URL}
      className={className}
    >
      <LogoDark
        width={width}
        alt={t`All Ears Logotyp`}
        className="dark:hidden"
      />
      <LogoLight
        width={width}
        alt={t`All Ears Logotyp`}
        className="hidden dark:block"
      />
    </a>
  );
}
